import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable, Subject } from 'rxjs';
import { ActiveToast, IndividualConfig, ToastrService } from 'ngx-toastr';
import { MessageType } from 'src/app/models';
import { Helpers } from '../helpers';


@Injectable({ providedIn: 'root' })
export class MedPointToastService {
  onRemoveToast = new EventEmitter<any>();

  constructor(private toastr: ToastrService) {
  }

  private getToastId(toastUniqueId: any) {
    let toast = this.toastr.toasts.filter(x => x.toastRef.componentInstance.uniqueId == toastUniqueId);
    return toast.length > 0 ? toast[0] : null;
  }

  show(toastUniqueId: string, title: string, message: string, messageType: MessageType, medptToastConfig?: Partial<IndividualConfig>, data?: any) {
    let toastIns = this.toastr.toasts.filter(x => x.toastRef.componentInstance.uniqueId == toastUniqueId.toLowerCase());
    let canShowNewToast = true;
    if (toastIns.length > 0) {
      if (toastIns[0].toastRef.componentInstance.messageType != messageType) {
        this.remove(toastUniqueId);
      } else {
        canShowNewToast = false;
      }
    }    
    
    if (canShowNewToast) {
      
      let toast!: ActiveToast<any>;
      let config = messageType == MessageType.Inprogress ? { ...medptToastConfig, toastClass: 'toast-inprogress' } : medptToastConfig;
      //if (Helpers.IsLocal()) {
      //  config = { ...medptToastConfig, closeButton:true, disableTimeOut: true, tapToDismiss: false };
      //}
      if (messageType == MessageType.Inprogress || messageType == MessageType.Info)
        toast = this.toastr.info(message, title, config);
      else if (messageType == MessageType.Success)
        toast = this.toastr.success(message, title, config);
      else if (messageType == MessageType.Warning)
        toast = this.toastr.warning(message, title, config);
      else if (messageType == MessageType.Error)
        toast = this.toastr.error(message, title, config);

      toast.onAction.subscribe((toastData: any) => {
        this.onRemoveToast.next(toastData.data);
      });

      toast.toastRef.componentInstance.uniqueId = toastUniqueId.toLowerCase();
      toast.toastRef.componentInstance.messageType = messageType;
      toast.toastRef.componentInstance.data = data;
    }
  }

  removeAll() {
    this.toastr.clear();
  }
  remove(ToastUniqueId: string) {
    let toast = this.getToastId(ToastUniqueId);
    if (toast)
      this.toastr.remove(<number>toast?.toastId);
  }
}
